<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit">
      <h1>Falta pouco!</h1>
      <p>Para finalizar, precisamos validar as informações que você nos forneceu através de alguns comprovantes.</p>    
    </div>
    <div class="text-center fixedOptions">
      <button v-focus @click="onSubmit" class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button> 
    </div>
  </div>
</template>

<script>
export default {
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      this.$emit('on-submit', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/AvisoDocumentosStep.vue